import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-allowances-details-grid',
  templateUrl: './allowances-details-grid.component.html',
  styleUrls: ['./allowances-details-grid.component.css']
})
export class AllowancesDetailsGridComponent implements OnInit {

  title="View Allowance details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/allowances-details/allowances-details-grid/allowances-details-grid.component.ts